import EmptyPlaceholder from '@orientaction/commons/EmptyPlaceholder';
import classNames from 'classnames';
import { FC } from 'react';
import style from './style';

interface IProps {
  hasError?: boolean;
}

const NoVariable: FC<IProps> = ({ hasError = false }) => {
  const classes = style();
  return (
    <EmptyPlaceholder
      overrideStyle={classNames(classes.root, hasError && classes.error)}
      placeholder="Aucune variable créée"
    />
  );
};

export default NoVariable;
